/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Og_Cfg_Standings_Always_PublicInputs */



/**
* | output |
* | --- |
* | "Players see the full preliminary standings once the finals start, and the full standings once the tournament finishes." |
*
* @param {Og_Cfg_Standings_Always_PublicInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const og_cfg_standings_always_public = /** @type {((inputs?: Og_Cfg_Standings_Always_PublicInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Og_Cfg_Standings_Always_PublicInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les joueurs voient le classement préliminaire complet dès le début de la finale, et le classement complet une fois le tournoi terminé.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Los jugadores ven la clasificación preliminar completa en cuanto empiecen las finales, y la clasificación completa al terminar el torneo.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Os jogadores veem a classificação preliminar completa assim que as finais começam, e a classificação completa quando o torneio termina.")
	if (locale === "it") return /** @type {LocalizedString} */ ("I giocatori vedono la classifica preliminare completa non appena iniziano le finali, e la classifica completa al termine del torneo.")
	return /** @type {LocalizedString} */ ("Players see the full preliminary standings once the finals start, and the full standings once the tournament finishes.")
});